import(/* webpackMode: "eager", webpackExports: ["LoginBoxDynamic"] */ "/tmp/seed/source/app/login/LoginBoxDynamic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Card"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/components/Card/Card.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Center"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/components/Center/Center.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/components/Image/Image.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/core/Box/Box.mjs");
